import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "./contexts/CartContext";
import { useTheme } from "./contexts/ThemeContext";
import { ShoppingCart, Home } from "lucide-react";
import logo from "./assets/logo.png";

export default function Contact() {
  const navigate = useNavigate();
  const { itemCount } = useCart();
  const { darkMode, setDarkMode } = useTheme();

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      alert("Please fill all fields.");
      return;
    }

    alert("💖 Thank you for contacting Bubble Butter!");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gradient-to-b from-white to-pink-50 dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-200 font-sans">

        {/* ===== HEADER ===== */}
        <header className="w-full h-16 md:h-20 shadow-sm bg-white/80 dark:bg-gray-900/80 backdrop-blur-md sticky top-0 z-50">
          <div className="max-w-6xl mx-auto flex items-center justify-between h-full px-4 gap-4">

            {/* Mobile Home */}
            <button
              onClick={() => navigate("/")}
              className="md:hidden p-2 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition"
            >
              <Home size={22} />
            </button>

            {/* Logo */}
            <div
              onClick={() => navigate("/")}
              className="flex items-center gap-3 cursor-pointer"
            >
              <img src={logo} alt="Bubble Butter" className="h-14 md:h-16" />
              <h1 className="text-xl md:text-2xl font-bold text-pink-600 dark:text-pink-300">
                Bubble Butter
              </h1>
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-4">
              <button onClick={() => navigate("/")} className="hover:text-pink-600 dark:hover:text-pink-300">
                Home
              </button>
              <button onClick={() => navigate("/products")} className="hover:text-pink-600 dark:hover:text-pink-300">
                Products
              </button>

              <button
                onClick={() => navigate("/cart")}
                className="relative px-3 py-2 rounded-lg bg-pink-600 text-white shadow"
              >
                <ShoppingCart size={18} />
                {itemCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-yellow-400 text-black text-xs px-2 rounded-full font-bold">
                    {itemCount}
                  </span>
                )}
              </button>

              {/* Theme Toggle */}
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition shadow-sm"
              >
                {darkMode ? "🌙" : "☀️"}
              </button>
            </div>

            {/* Mobile Cart */}
            <div className="md:hidden">
              <button
                onClick={() => navigate("/cart")}
                className="relative p-2 rounded-lg bg-pink-600 text-white shadow"
              >
                <ShoppingCart size={20} />
                {itemCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-yellow-400 text-black text-xs px-1.5 rounded-full font-bold">
                    {itemCount}
                  </span>
                )}
              </button>
            </div>
          </div>
        </header>

        {/* ===== CONTACT SECTION ===== */}
        <main className="max-w-6xl mx-auto px-4 mt-10 pb-32">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-pink-600 dark:text-pink-300 mb-6">
            Contact Us
          </h2>

          <div className="max-w-md mx-auto bg-white dark:bg-gray-800 shadow rounded-2xl p-6 space-y-4">
            <form onSubmit={handleSubmit} className="space-y-4">

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 focus:outline-none"
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 focus:outline-none"
              />

              <textarea
                name="message"
                rows="4"
                placeholder="Your Message"
                value={form.message}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 focus:outline-none resize-none"
              />

              <button
                type="submit"
                className="w-full py-3 rounded-xl bg-pink-600 hover:bg-pink-700 text-white transition font-medium shadow"
              >
                Send Message
              </button>
            </form>

            <div className="text-center text-sm text-gray-500 dark:text-gray-400 pt-2">
              <p>Email: support@bubblebutter.in</p>
              <p>Instagram: @bubblebutter</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
